<template>
  <div class="slider-viewer">
    <DefaultViewer v-if="windowWidth >= SLIDER_ADAPTIVE_SCREEN_SIZE" />
    <AdaptiveViewer v-else />
  </div>
</template>

<script setup>
  import { ref, onMounted } from 'vue';
  import { SLIDER_ADAPTIVE_SCREEN_SIZE } from '@/Groups/Slider/private/config/config';
  //--------------------------------
  import DefaultViewer from '@/Groups/Slider/private/core/DefaultViewer/DefaultViewer.vue';
  import AdaptiveViewer from '@/Groups/Slider/private/core/AdaptiveViewer/AdaptiveViewer.vue';
  //--------------------------------
  const windowWidth = ref(0)
  //--------------------------------
  onMounted(() => {
    windowWidth.value = window.innerWidth
  })
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>